import { ActivitiesValidateResponse } from '@app/modules/activities/entities/activities-booking';
import { ProductProperties } from '@app/modules/avo/interface/trigger-props';

export function activitiesPropsFromValidation(validation: ActivitiesValidateResponse): ProductProperties {
  const productDetails = validation?.Products?.ProductsDetails?.[0];
  const fares = productDetails?.Fares?.[0];
  const productProps = {
    TRAVEL_PRODUCT_CODE: productDetails?.ProductCode,
    TRAVEL_PRODUCT_NAME: productDetails?.ProductName,
    TRAVEL_PRODUCT_PRICE: fares?.SellPriceAmount.Total
  };
  return productProps;
}
